import { TFunction } from 'react-i18next'

interface Props {
  paymentMethod: string | undefined
  t: TFunction
}

export const PaymentInformation = ({ paymentMethod, t }: Props) => {
  if (!paymentMethod) {
    return (
      <div className="gap-semantic-global-2xs flex flex-col items-start text-left" data-e2e="payment-information">
        <label className="typography-body-md-medium text-semantic-global-info-darker text-left">{t('PAYMENT-METHOD')}</label>
        <span className="typography-body-md-regular text-semantic-global-text-light lg:typography-body-md-regular">
          {t('MISSING-CHECKOUT-INFORMATION')}
        </span>
      </div>
    )
  }
  return (
    <div className="gap-semantic-global-2xs flex flex-col" data-e2e="payment-information">
      {paymentMethod ? (
        <>
          <label className="typography-body-md-medium text-semantic-global-info-darker text-left">{t('PAYMENT-METHOD')}</label>
          <div className="typography-body-md-regular text-semantic-global-text-default flex flex-col">
            <div className="text-left">{paymentMethod === 'creditcard' ? t('CREDIT-CARD') : null}</div>
            <div className="text-left">{paymentMethod === 'paypal' ? t('PAYPAL') : null}</div>
          </div>
        </>
      ) : null}
    </div>
  )
}
